import templatePrivacy from './privacy-policy.html';
import templateRefund from './refund-policy.html';
import templateSecurity from './security-policy.html';
import templateBookingFee from './booking-fee.html';
import templateShowCVN from './show-cvn.html';
import {ModalController as controller} from './modal.controller';

const modalService = ($filter, $uibModal) => {
  /**
   * Return immutable object with the service's public interface
   */

  return Object.freeze({
    showModal (template) {
        const modalInstance = $uibModal.open({
                animation: true,
                template: template,
                controllerAs: 'vm',
                controller: controller//,
                //appendTo: 'modal-parent'
        });
        return modalInstance;
    },

    showPrivacy () {
        return this.showModal(templatePrivacy);
    },

      showRefund () {
          return this.showModal(templateRefund);
      },

      showSecurity () {
          return this.showModal(templateSecurity);
      },

      showBookingFee () {
          return this.showModal(templateBookingFee);
      },

      showCVN () {
          return this.showModal(templateShowCVN);
      }


  });
};

modalService.$inject = ['$filter', '$uibModal'];
export {modalService};



/** WEBPACK FOOTER **
 ** ./src/app/shared/services/modal/modal.service.js
 **/